<template>
  <div class="row main-content">
    <div class="col">
      <h1 class="page-title font-custom text-uppercase mt-3">
        {{ $t('title.distributorsList') }}
      </h1>

      <div v-if="$store.state.distributors.distributors.length">
        <!-- Table -->
        <div class="table-responsive">
          <table class="table table-hover table-sm table-striped border">
            <thead class="font-custom">
              <tr>
                <th>{{ $t('label.distributor.reference') }}</th>
                <th>{{ $t('label.distributor.name') }}</th>
                <th>{{ $t('label.distributor.issuerId') }}</th>
                <th>{{ $t('label.distributor.creationDate') }}</th>
                <th>{{ $t('label.distributor.closingDate') }}</th>
                <th>{{ $t('label.distributor.country') }}</th>
                <!-- th>P1b1 Extract Mode</th>
                <th>P1b1 Encryption Key Index</th -->
                <th>{{ $t('label.actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="distributor in displayedDistributors"
                :key="distributor.id"
                class="mb-3"
              >
                <td>{{ distributor.reference }}</td>
                <td>{{ distributor.name }}</td>
                <td>{{ distributor.issuerId }}</td>
                <td>{{ $filters.dateYYYYMMDDTirets(distributor.creationDate) }}</td>
                <td>{{ $filters.dateYYYYMMDDTirets(distributor.closingDate) }}</td>
                <td>{{ distributor.country }}</td>
                <!--td>{{ distributor.p1b1ExtractMode }}</td>
                <td>{{ distributor.p1b1EncryptionKeyIndex }}</td -->
                <td>
                  <template v-if="distributor.reference != '99999'">
                    <!-- client do not want to see it, commented just in case we might need it later -->
                    <!-- <BaseButton
                      v-if="hasPermission('distributors:write')"
                      type="button"
                      class="btn-white btn-sm d-inline border me-2"
                      @click-base-button-event-emitter="editDistributor(distributor)"
                    >
                      {{ $t('button.edit') }}
                    </BaseButton> -->
                    <BaseButton
                      v-if="hasPermission('product:create')"
                      type="button"
                      class="btn-primary btn-sm d-inline font-inverted"
                      @click-base-button-event-emitter="showCreate(distributor)"
                    >
                      {{ $t('button.distributor.createProduct') }}
                    </BaseButton>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Pager -->
        <Pager
          :posts="$store.state.distributors.distributors"
          @page-update="displayedDistributors = $event;"
        />
      </div>

      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="center-block lazyload"
        >
      </div>
      <div
        v-else-if="error"
        class="alert alert-warning text-center border-0 shadow-sm rounded-0"
      >
        {{ $t('error.'+`${responseErr}`) }}
      </div>
    </div>
  </div>
</template>

<script src="./DistributorList.js"></script>

<style src="./DistributorList.scss" scoped lang="scss"></style>
